module.exports = __webpack_public_path__ + "img/pro_bg.e8b4c9bf.jpg";